import React from 'react';
const Impressum: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-background-dark">
      {/* Hero Section */}
      <section className="relative h-[400px] overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="/images/facilities/training-field-2.jpg" 
            alt="Vereinsgelände" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative h-full flex items-center">
          <div className="container mx-auto px-4 max-w-5xl">
            <div className="max-w-2xl">
              <h1 className="text-3xl md:text-5xl font-black text-white mb-4 md:mb-6 uppercase">
                Impressum
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 md:py-16">
        <div className="container mx-auto px-4 max-w-5xl">
          <div className="space-y-6 md:space-y-8">
            <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
              <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                Angaben gemäß § 5 TMG
              </h2>
              
              <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Anschrift:
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    HSV Berlin Adlershof e. V.<br />
                    Birkenweg<br />
                    12439 Berlin
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Vertretungsberechtigter:
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Toni Meier, 1. Vorsitzender<br />
                    E-Mail: info@hsv-adlershof.berlin<br />
                    Tel: 0162/2068729
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Registereintrag:
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Eingetragen am Amtsgericht Charlottenburg<br />
                    Registernummer: VR 13031 B
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Die Seite wurde erstellt vom Vereinsmitglied Markus Tietke im Auftrag des Vereins. 
                    Haftung übernimmt der Verein.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 dark:bg-surface-dark rounded-lg p-5 md:p-8">
              <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-neutral-900 dark:text-neutral-100">
                Haftungsausschluss
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Haftung für Inhalte
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                    nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                    Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                    Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                    Tätigkeit hinweisen.
                  </p>
                  <p className="text-neutral-600 dark:text-neutral-400 mt-3">
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                    allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                    erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
                    Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Haftung für Links
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                    Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                    Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                    Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
                    mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
                    Verlinkung nicht erkennbar.
                  </p>
                  <p className="text-neutral-600 dark:text-neutral-400 mt-3">
                    Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
                    Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                    Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Urheberrecht
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                    dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                    der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                    Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
                    nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                  </p>
                  <p className="text-neutral-600 dark:text-neutral-400 mt-3">
                    Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
                    Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
                    gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
                    bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
                    werden wir derartige Inhalte umgehend entfernen.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold mb-3 text-neutral-900 dark:text-neutral-100">
                    Streitschlichtung
                  </h3>
                  <p className="text-neutral-600 dark:text-neutral-400">
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center mt-8">
              <p className="text-sm text-neutral-500 dark:text-neutral-400">
                Stand: Januar 2025
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;